// @flow
import { execute }        from 'fg-frontend/src/partialUpdate/partialUpdate';
import * as CursorSpinner from 'fg-frontend/src/components/CursorSpinner';

import closeEsp         from 'fg-frontend/webActions/closeEsp';
import goBack           from 'fg-frontend/webActions/goBack';
import scrollToHref     from 'fg-frontend/webActions/scrollToHref';
import confirmPopup     from 'fg-frontend/webActions/confirmPopup';
import passwordStrength from 'fg-frontend/webActions/passwordStrength';
import toggleClass from 'fg-frontend/webActions/toggleClass';
import printPage from 'fg-frontend/webActions/printPage';
import headerNavDropdownHandler from './webActions/headerNavDropdownHandler';
import headerSubNavDropdownHandler from './webActions/headerSubNavDropdownHandler';
import closeFilter from './webActions/closeFilter';

// import configureEshopActions from './configureEshopActions';

export default (action) => {
	switch (action) {
		case 'hsExpand':
			return (props, e) => {
				e.preventDefault();
				CursorSpinner.pushToQueue('importHsExpand');
				import('./webActions/hsExpand').then((hsExpand) => {
					CursorSpinner.removeFromQueue('importHsExpand');
					hsExpand.default(props, e);
				});
			};
		case 'execute':
			return execute;
		case 'closeEsp':
			return closeEsp;
		case 'goBack':
			return goBack;
		case 'scrollToHref':
			return scrollToHref;
		case 'passwordStrength':
			return passwordStrength;
		case 'confirmPopup':
			return confirmPopup;
		case 'toggleClass':
			return toggleClass;
		case 'headerNavDropdownHandler':
			return headerNavDropdownHandler;
		case 'headerSubNavDropdownHandler':
			return headerSubNavDropdownHandler;
		case 'closeFilter':
			return closeFilter;
		case 'printPage':
			return printPage;
			default:
				/*const eshopAction = configureEshopActions(action);
				if (eshopAction) {
					return eshopAction;
				}
				else {
					console.log(`Unknown action`);
					return null;
				}*/
				console.log(`Unknown action`);
				return null;
		}
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWebActions.js